module.exports = __webpack_public_path__ + "static/media/medicine.bf38e44b.jpg";